import axios from "axios";

export default {
  methods: {
    /**
     * Retorna uma listagem com todos os arquivos já enviados
     * @param {Number} idRnpPrestador
     * @return {
     * [
     *    {
     *      "arquivo": "string",
     *      "baixavel": true,
     *      "dtAlteracao": "string",
     *      "dtUpload": "string",
     *      "id": 0,
     *      "status": {
     *        "chave": "PROCESSANDO",
     *        "descricao": "string"
     *      },
     *      "usuarioAlteracao": {
     *        "id": 0,
     *        "nome": "string"
     *      },
     *      "usuarioUpload": {
     *        "id": 0,
     *        "nome": "string"
     *      },
     *      "uuid": "string"
     *    }
     *  ]
     * }
     */
    getArquivosAnexo(idRnpPrestador) {
      return axios.get(
        this.CriarUrl({
          resource: `anexos/${idRnpPrestador}`
        })
      );
    },
    /**
     * Faz o upload do arquivo
     * @param {FormData} formData
     * @param {Number} idRnpPrestador
     */
    postUploadArquivo(formData, idRnpPrestador, onProgress) {
      return axios.post(
        this.CriarUrl({
          resource: `anexos/upload/${idRnpPrestador}`
        }),
        formData,
        {
          onUploadProgress(progressEvent) {
            let porcentagem = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );

            if (onProgress) onProgress(porcentagem);

            return porcentagem;
          }
        }
      );
    },
    /**
     * Baixa o arquivo
     * @param {String} uuid
     */
    getDownloadArquivo(uuid) {
      return axios.get(
        this.CriarUrl({
          resource: `anexos/download/${uuid}`
        }),
        {
          responseType: "blob"
        }
      );
    },

    /**
     * atualizar descrição do anexo no fluxo de singular
     * @param {Number} id
     * @param {String} descricao
     */
    putDescricaoAnexo(id, descricao) {
      return axios.put(
        this.CriarUrl({
          resource: `anexos/descricao/${id}?descricao=${descricao}`
        })
      );
    },

    /// FLUXO ANALISTA/ADM

    /**
     * Delete o arquivo
     * @param {String} uuid
     */
    deleteArquivo(id, uuid) {
      return axios.delete(
        this.CriarUrl({
          resource: `anexos/delete/${id}?uuid=${uuid}`
        })
      );
    }
  }
};
